export enum BrazeContentCardTypes {
  BANNER_V1 = 'bannerV1',
  RIVALS = 'rivals',
}

export type BrazeAPI = {
  subscribeToContentCardsUpdates: (cb?: (data: BrazeData) => void) => void;
  getCachedContentCards: () => BrazeCard[];
  requestContentCardsRefresh: (
    successCb?: () => void,
    errorCb?: () => void
  ) => void;
  logContentCardImpressions: (cards: BrazeCard[]) => void;
  logContentCardClick: (card: BrazeCard) => void;
  logCustomEvent: (eventName: string) => boolean;
};

export type BrazeData = { cards: BrazeCard[] };
type BrazeCardExtras = {
  type: BrazeContentCardTypes;
  priority: string;
  iconURL: string;
  height?: number;
  borderColor: string;
  backgroundURL: string;
  badge: string;
  customEvent?: string;
};
export type BrazeCard = {
  id: string;
  extras: BrazeCardExtras;
  created: string;
  title: string;
  description: string;
  url: string;
};
